export default __webpack_public_path__ + "static/media/kyoko_background.5adefc78.jpeg";